import { Subscription, Project } from '@owl-nest/api-client/latest'
import { Reward } from './reward'

export function getReward<PROJECT_EXTRA_FIELDS extends string = ''>(
	subscription: Subscription,
	project: Project<PROJECT_EXTRA_FIELDS>,
      ): Reward<PROJECT_EXTRA_FIELDS> | undefined {
	if (subscription.reward) {
	  return Reward(subscription.reward, project)
	}
}
